import { connect } from 'react-redux'
import ActionBar from '../../../components/Sections/Propiedades/ActionBar'
import { setListType } from '../../../actions/propiedades';
import { setCantElements, setOrder } from '../../../actions/meta';
import { saveOrder } from '../../../actions/propiedades';

const mapStateToProps = (state, ownProps) => {
  return {
  	listType: state.propiedades.listType,
    originPath: state.searchBar.originPath,
    originOffice: state.searchBar.originOffice,
    cantElements: state.meta.page_lenght,
    property_type: state.searchBar.property_type,
    order: state.propiedades.order_by
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  	onClickViewGallery: () => dispatch(setListType('gallery')),
  	onClickViewList: () => dispatch(setListType('list')),
    onClickViewMap: () => dispatch(setListType('map')),
    onChangeCantElements: value => dispatch(setCantElements(value)),
    onChangeOrder: value => {
      dispatch(setOrder(value.id))
      dispatch(saveOrder(value))    
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionBar)


// WEBPACK FOOTER //
// ./src/containers/Sections/Propiedades/actionBar.js